import React, { useState } from 'react';
import { Clock, BarChart2, Calendar, AlertTriangle } from 'lucide-react';
interface DashboardProps {
  onStartRunbook: (type: string) => void;
}
export const Dashboard: React.FC<DashboardProps> = ({
  onStartRunbook
}) => {
  const [storeStatus, setStoreStatus] = useState('open');
  const currentTime = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
  return <div className="p-4 space-y-6" data-id="element-194">
      <div className="flex flex-col" data-id="element-195">
        <span className="text-sm text-gray-500" data-id="element-196">{currentDate}</span>
        <div className="flex justify-between items-center" data-id="element-197">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-198">
            Good Evening, Alex
          </h2>
          <div className="flex items-center" data-id="element-199">
            <Clock className="w-4 h-4 text-gray-500 mr-1" data-id="element-200" />
            <span className="text-sm text-gray-500" data-id="element-201">{currentTime}</span>
          </div>
        </div>
      </div>
      {/* Store Status Card */}
      <div className="bg-white rounded-lg shadow p-4" data-id="element-202">
        <div className="flex justify-between items-center" data-id="element-203">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-204">Store Status</h3>
          <span className={`px-2 py-1 text-xs font-medium rounded-full ${storeStatus === 'open' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-205">
            {storeStatus === 'open' ? 'Open' : 'Closed'}
          </span>
        </div>
        <div className="mt-2 space-y-2" data-id="element-206">
          <div className="flex justify-between text-sm" data-id="element-207">
            <span className="text-gray-500" data-id="element-208">Opening Time</span>
            <span className="font-medium" data-id="element-209">9:00 AM</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-210">
            <span className="text-gray-500" data-id="element-211">Closing Time</span>
            <span className="font-medium" data-id="element-212">9:00 PM</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-213">
            <span className="text-gray-500" data-id="element-214">Shift Lead</span>
            <span className="font-medium" data-id="element-215">Jamie Smith</span>
          </div>
        </div>
      </div>
      {/* AI Insights */}
      <div className="bg-white rounded-lg shadow p-4" data-id="element-216">
        <div className="flex items-center mb-3" data-id="element-217">
          <BarChart2 className="w-5 h-5 text-blue-600 mr-2" data-id="element-218" />
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-219">AI Insights</h3>
        </div>
        <div className="space-y-3" data-id="element-220">
          <div className="flex items-start p-3 bg-yellow-50 rounded-md" data-id="element-221">
            <AlertTriangle className="w-5 h-5 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-222" />
            <div data-id="element-223">
              <p className="text-sm font-medium text-gray-900" data-id="element-224">
                Register #2 shows higher than average voids today
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-225">
                Recommend reviewing transactions during closing
              </p>
            </div>
          </div>
          <div className="flex items-start p-3 bg-blue-50 rounded-md" data-id="element-226">
            <Calendar className="w-5 h-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-227" />
            <div data-id="element-228">
              <p className="text-sm font-medium text-gray-900" data-id="element-229">
                Suggested closing time: 8:30 PM
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-230">
                Based on current traffic patterns
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Runbooks Section */}
      <div data-id="element-231">
        <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-232">
          Start a Runbook
        </h3>
        <div className="grid grid-cols-1 gap-3" data-id="element-233">
          <button onClick={() => onStartRunbook('closing')} className="bg-white border border-gray-200 rounded-lg p-4 text-left hover:bg-gray-50 transition-colors" data-id="element-234">
            <h4 className="font-medium text-gray-900" data-id="element-235">End-of-Day Closing</h4>
            <p className="text-sm text-gray-500 mt-1" data-id="element-236">
              Complete cash reconciliation and security checks
            </p>
          </button>
          <button className="bg-white border border-gray-200 rounded-lg p-4 text-left hover:bg-gray-50 transition-colors opacity-60" data-id="element-237">
            <h4 className="font-medium text-gray-900" data-id="element-238">Morning Opening</h4>
            <p className="text-sm text-gray-500 mt-1" data-id="element-239">
              Prepare store for daily operations
            </p>
          </button>
          <button className="bg-white border border-gray-200 rounded-lg p-4 text-left hover:bg-gray-50 transition-colors opacity-60" data-id="element-240">
            <h4 className="font-medium text-gray-900" data-id="element-241">Shift Change</h4>
            <p className="text-sm text-gray-500 mt-1" data-id="element-242">
              Transfer responsibilities between shifts
            </p>
          </button>
        </div>
      </div>
    </div>;
};